import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

export const PATH_IMPERSONATE = "/member/impersonate";

/** The screen replacing the removed `/member/admin/sign-in-as-member`. */
export const PATH_IMPERSONATE_LEGACY = "/member/admin/sign-in-as-member";

/** Staff-only form — no params, nothing to deep-link. */
export const routeHelpersImpersonate = createRouteHelpers(PATH_IMPERSONATE);
